const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    slidesPerView: 1,　//一度に表示するスライド枚数
    spaceBetween: 0,　//スライド間の余白
    loop: true,　//ループさせるか？
    speed: 1000,　//スライド速度
    effect: "fade",　//スライドをフェードで切り替える
    autoplay: {
        delay: 3000,
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });